import { render, staticRenderFns } from "./BadgeDefault.vue?vue&type=template&id=423e1d47&scoped=true&"
import script from "./BadgeDefault.vue?vue&type=script&lang=js&"
export * from "./BadgeDefault.vue?vue&type=script&lang=js&"
import style0 from "./BadgeDefault.vue?vue&type=style&index=0&id=423e1d47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e1d47",
  null
  
)

export default component.exports